import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretDownMdLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.97982 6.31344C5.17508 6.11818 5.49167 6.11818 5.68693 6.31344L8.00004 8.62652L10.3132 6.31344C10.5084 6.11818 10.825 6.11818 11.0202 6.31344C11.2155 6.5087 11.2155 6.82526 11.0202 7.02052L8.35357 9.68719C8.15831 9.88246 7.84177 9.88246 7.64651 9.68719L4.97982 7.02052C4.78456 6.82526 4.78456 6.5087 4.97982 6.31344Z",
		fill: "currentColor"
	})
});
export default SvgCaretDownMdLine;
